import { render } from "./VendorDashboardInner.vue?vue&type=template&id=f8f3c804&scoped=true"
import script from "./VendorDashboardInner.vue?vue&type=script&lang=js"
export * from "./VendorDashboardInner.vue?vue&type=script&lang=js"

import "./VendorDashboardInner.vue?vue&type=style&index=0&id=f8f3c804&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f3c804"]])

export default __exports__